import * as DialogPrimitive from "@radix-ui/react-dialog";
import { Link } from "react-router-dom";
import { ArrowRight, X } from "lucide-react";
import { Dialog, DialogPortal, DialogOverlay, DialogTitle, DialogDescription, DialogClose } from "@/components/ui/dialog";
import { offerDate } from "@/data/offers";
import { useBrokers } from "@/context/BrokersContext";

export const OfferDialog = ({ offer, onClose }) => {
  const { getBroker } = useBrokers();
  const broker = offer && getBroker(offer.brokerSlug);
  return (
    <Dialog open={!!offer} onOpenChange={(open) => { if (!open) onClose(); }}>
      {offer && <DialogPortal>
        <DialogOverlay className="bg-black/30 backdrop-blur-sm" data-testid="offer-dialog-overlay" />
        <DialogPrimitive.Content className="offer-dialog" data-testid="offer-dialog" data-lenis-prevent>
          <div className="offer-broker"><img src={broker.logo} alt="" width="44" height="44" data-testid="offer-dialog-logo" /><span data-testid="offer-dialog-broker">{broker.name}</span></div>
          <DialogClose asChild><button className="offer-dialog-close" aria-label="Close offer" data-testid="offer-dialog-close"><X size={18} /></button></DialogClose>
          <span className="offer-category" data-testid="offer-dialog-category">{offer.category}</span>
          <DialogTitle className="t-h4" data-testid="offer-dialog-title">{offer.title}</DialogTitle>
          <DialogDescription data-testid="offer-dialog-description">{offer.description}</DialogDescription>
          <div className="offer-dialog-benefit" data-testid="offer-dialog-benefit"><strong>{offer.benefit}</strong><span>{offer.benefitLabel}</span></div>
          <h3 className="t-h6">Offer details</h3>
          <ul data-testid="offer-dialog-terms">{offer.terms.map((term) => <li key={term}>{term}</li>)}</ul>
          <p className="offer-dialog-expiry" data-testid="offer-dialog-expiry">Ends <time dateTime={offer.expiresAt}>{offerDate(offer.expiresAt)}</time></p>
          <p className="offer-dialog-notice" data-testid="offer-dialog-notice">Synthetic promotion for this prototype. This offer cannot be claimed. Availability and terms are illustrative, not verified broker promotions.</p>
          <Link to={`/brokers/${broker.slug}`} onClick={onClose} className="offer-view-button" data-testid="offer-dialog-broker-link">View broker profile <ArrowRight size={14} /></Link>
        </DialogPrimitive.Content>
      </DialogPortal>}
    </Dialog>
  );
};